export default {
    appTitle: process.env.VUE_APP_TITLE,
    networkOnLine: true,
    SWRegistrationForNewContent: null,
    showAddToHomeScreenModalForApple: false,
    refreshingApp: false,
    appVersion: '0.4.9',
};